import React from 'react'
import PropTypes from 'prop-types'
import {
  SelectDropdownFormField,
  NumberFormField,
} from 'belle-js'
import { NavLink } from 'redux-first-router-link'
import styles from './ContactDropdown.module.scss'
import formStyles from '../ContactIndexForm.module.scss'
import classnames from 'classnames'

class ContactDropdown extends React.Component {

  constructor (props) {
    super(props)
    this.handleDropdownChange = this.handleDropdownChange.bind(this)
  }

  handleDropdownChange (e) {
    const { onChange } = this.props
    onChange(e)
  }

  render () {
    const {
      filteredOptions,
      showEditOptions,
      contact,
      editPath,
      onDelete,
      dropdownName,
      isFirstDropdown,
      formType,
      shouldRenderEdit,
      showAdditionalFields
    } = this.props

    const { sharePercentage, name, id } = contact
    const sharePercentageMissing = sharePercentage === undefined || sharePercentage === null
    const sharePercentagePresent = !sharePercentageMissing
    let percentage = isFirstDropdown ? 100 : 0
    percentage = sharePercentagePresent ? sharePercentage : percentage
    const renderEditStyles = shouldRenderEdit ? formStyles.secondaryCTA : formStyles.primaryCTA
    const isIndividualBeneficiary = (!!contact.firstName) && (contact.role === 'Beneficiary')
    const detailStyles = (isIndividualBeneficiary && !contact.relationship) && formStyles.errorCTA

    return (
      <div className={styles.ContactDropdown}>
        <div className={styles.row}>
          <SelectDropdownFormField
            name={formType ?
              `${dropdownName}_name_${formType}` :
              `${dropdownName}_name`}
            label=""
            placeholder="Select a contact"
            className={styles.formField}
            options={filteredOptions}
            value={name}
            required={false}
            onChange={this.handleDropdownChange}  />
          <div className={styles.rightSide}>
            {id &&
              <div className={styles.actions}>
                { showEditOptions &&
                  <NavLink to={editPath}>
                    <span
                      className={classnames(renderEditStyles, detailStyles)}>
                      { shouldRenderEdit ? 'Edit' : 'Add details'}
                    </span>
                  </NavLink>
                }
                <a
                  type="button"
                  onClick={() => {onDelete(id)}} >
                  <span className={formStyles.secondaryCTA}>Remove</span>
                </a>
              </div>
            }
          </div>
        </div>
        {id && showAdditionalFields &&
        <div className={styles.percentageSectionWrapper}>
          <div className={styles.percentageSection}>
            <NumberFormField
              name={formType ?
                `${dropdownName}_percentage_${formType}` :
                `${dropdownName}_percentage`}
              label=""
              format="percentage"
              className={styles.textField}
              maxLength={5}
              validations={{ isValidPositivePercentage: true }}
              validationErrors={{
                isValidPositivePercentage: 'Beneficiary must receive positive value'
              }}
              value={percentage} />
          </div>
        </div>}
      </div>
    )
  }
}

ContactDropdown.propTypes = {
  filteredOptions: PropTypes.array.isRequired,
  contact: PropTypes.object,
  editPath: PropTypes.string,
  isFirstDropdown: PropTypes.bool,
  onDelete: PropTypes.func.isRequired,
  onChange: PropTypes.func.isRequired,
  dropdownName: PropTypes.string.isRequired,
  formType: PropTypes.string.isRequired,
  shouldRenderEdit: PropTypes.bool,
  showEditOptions: PropTypes.bool,
  showAdditionalFields: PropTypes.bool
}

ContactDropdown.defaultProps = {
  showAdditionalFields: false,
  contact: {},
  editPath: '',
  isFirstDropdown: false,
  shouldRenderEdit: false,
  showEditOptions: false
}

export default ContactDropdown



// WEBPACK FOOTER //
// ./src/components/Onboarding/Accounts/ContactIndexForm/ContactDropdown/ContactDropdown.jsx